export default __webpack_public_path__ + "static/product1-2176b6494c9cba3f4c4bc0f302656b65.png";